import React from "react";
import ErrorPage from "./errorPage";

type MyProps = {};
type MyState = { error: any; errorInfo: any };

class ErrorBoundary extends React.Component<MyProps, MyState> {
  constructor(props: any) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidMount() {
    console.log("execute");
  }

  componentDidCatch(error: any, errorInfo: any) {
    // Catch errors in any components below and re-render with error message
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });
    console.log('componentDidCatch')
    localStorage.clear();
  }

  render() {
    if (this.state.errorInfo) {
      return (
       <ErrorPage/>
      );
    }
    return this.props.children;
  }
}
export default ErrorBoundary;
